import React from "react";
import NHFetch from "../../../../utils/NHFetch";
import JxBdtjcx from "../jxBdtjcx";//基线
import NhgsBdtjcx from "../nhgsBdtjcx";//广东南华工商

const baseUrlPath = "/swbl/lstd"; //基础路径
/**
 * 通用学生报到统计
 * @author yangqizhi
 */
class index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuCode: [],//null是基线
        };
    }

    componentDidMount() {
        this.getMenuCode();
    }

    getMenuCode = () => {
        let cds = ["xsbdtj"];
        NHFetch(baseUrlPath + '/getXmdcd', 'POST', cds).then(res => {
            if (res) {
                if (res && res.code == 200) {
                    let menuCode = res.data;
                    this.setState({
                        menuCode
                    })
                }
            }
        });
    }

    render() {
        const {menuCode} = this.state;
        return (
          <div>
              {
                  menuCode && menuCode.length > 0 && menuCode.map((item, index) => {
                      if (item.JC == "gdnhgs") {
                          return <NhgsBdtjcx/>
                      } else {
                          return <JxBdtjcx/>
                      }
                  })
              }
              {(menuCode == null || menuCode.length == 0) && <JxBdtjcx/>}
          </div>
        );
    }
}

export default index;



// WEBPACK FOOTER //
// ./components/tjcx/bdtjcx/tyBdtjcx/index.js